import { type JSX } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

/**
 * Picks the right home page for the active session:
 *  - role='agent' → /agent/commissions (the agent portal — no
 *    customer-facing nav, just the commission report)
 *  - tenant_type in {platform, reseller} → /admin/dashboard
 *  - everything else (customer / unset) → /dashboard
 *
 * Used by the index route and the catch-all so a fresh login lands on
 * the right home for the role + tenant combination.
 */
export function HomeRedirect(): JSX.Element {
  const { user } = useAuth();
  let dest = '/dashboard';
  if (user?.role === 'agent') {
    dest = '/agent/commissions';
  } else if (user?.tenantType === 'platform' || user?.tenantType === 'reseller') {
    dest = '/admin/dashboard';
  }
  return <Navigate to={dest} replace />;
}
